import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PasscodeSheet } from "../components/PasscodeSheet";
import { changePasscodeApi } from "../lib/api";

type Step = "current" | "new" | "confirm";

export default function PasscodeChange() {
  const navigate = useNavigate();
  const [step, setStep] = useState<Step>("current");
  const [current, setCurrent] = useState<string>("");
  const [next, setNext] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (code: string) => {
    setError(null);
    if (step === "current") {
      setCurrent(code);
      setStep("new");
      return;
    }
    if (step === "new") {
      setNext(code);
      setStep("confirm");
      return;
    }
    // step === "confirm"
    if (code !== next) {
      setError("Codes don't match — start over");
      setStep("new");
      setNext("");
      return;
    }
    try {
      const r = await changePasscodeApi(current, next);
      if (!r.ok) {
        setError("Current passcode incorrect");
        setStep("current");
        setCurrent("");
        setNext("");
        return;
      }
      navigate(-1);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Change failed");
      setStep("current");
      setCurrent("");
      setNext("");
    }
  };

  const title = step === "current"
    ? "Enter current passcode"
    : step === "new"
      ? "Set new passcode"
      : "Confirm new passcode";

  return (
    <div className="min-h-screen flex flex-col items-center pt-12 px-4 bg-attic-bg">
      <button onClick={() => navigate(-1)} className="self-start text-attic-accent text-sm mb-3">‹ Back</button>
      <h2 className="text-lg font-bold mb-6">Change passcode</h2>
      <PasscodeSheet
        key={step}
        title={title}
        onSubmit={onSubmit}
        onCancel={() => navigate(-1)}
        errorMessage={error ?? undefined}
      />
    </div>
  );
}
